import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../profile-components/Navbar.css";

function SupportNavbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  useEffect(() => {
    const handleToggleMobileSidebar = () => {
      setIsMobileSidebarOpen((prev) => !prev);
    };

    const handleCloseMobileSidebar = () => {
      setIsMobileSidebarOpen(false);
    };

    window.addEventListener("toggle-mobile-sidebar", handleToggleMobileSidebar);
    window.addEventListener("close-mobile-sidebar", handleCloseMobileSidebar);

    return () => {
      window.removeEventListener("toggle-mobile-sidebar", handleToggleMobileSidebar);
      window.removeEventListener("close-mobile-sidebar", handleCloseMobileSidebar);
    };
  }, []);

  useEffect(() => {
    setIsMobileSidebarOpen(false);
  }, [location.pathname, location.search]);

  const closeMobileSidebar = () => {
    setIsMobileSidebarOpen(false);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/login");
  };

  const isActivePath = (path) => {
    if (path === "/support-admin") {
      return location.pathname === "/support-admin";
    }

    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  const isActiveStatus = (status) => {
    const params = new URLSearchParams(location.search);
    return (
      location.pathname === "/support-admin/tickets" &&
      params.get("status") === status
    );
  };

  const navLinkClass = (path) => {
    return `nav-link ${isActivePath(path) && !location.search ? "active" : ""}`;
  };

  const statusLinkClass = (status) => {
    return `nav-link ${isActiveStatus(status) ? "active" : ""}`;
  };

  const sidebarClassName = `sidebar ${isMobileSidebarOpen ? "sidebar-open" : ""}`;

  return (
    <>
      {isMobileSidebarOpen && (
        <button
          type="button"
          className="sidebar-backdrop"
          aria-label="Close navigation menu"
          onClick={closeMobileSidebar}
        />
      )}

      <div className={sidebarClassName}>
        <div className="logo">
          <div className="navbar-logo-placeholder">Agent Book CRM</div>
        </div>

        <Link
          to="/support-admin"
          className={navLinkClass("/support-admin")}
          onClick={closeMobileSidebar}
        >
          Support Dashboard
        </Link>

        <Link
          to="/support-admin/tickets"
          className={navLinkClass("/support-admin/tickets")}
          onClick={closeMobileSidebar}
        >
          Tickets
        </Link>

        <Link
          to="/support-admin/tickets?status=Open"
          className={statusLinkClass("Open")}
          onClick={closeMobileSidebar}
        >
          Open Tickets
        </Link>

        <Link
          to="/support-admin/tickets?status=Waiting%20on%20Customer"
          className={statusLinkClass("Waiting on Customer")}
          onClick={closeMobileSidebar}
        >
          Waiting on Customer
        </Link>

        <Link
          to="/support-admin/tickets?status=Resolved"
          className={statusLinkClass("Resolved")}
          onClick={closeMobileSidebar}
        >
          Resolved
        </Link>

        <Link
          to="/support-admin/tickets?status=Closed"
          className={statusLinkClass("Closed")}
          onClick={closeMobileSidebar}
        >
          Closed Tickets
        </Link>

        <button
          type="button"
          className="nav-link logout-button"
          onClick={handleLogout}
        >
          Logout
        </button>
      </div>
    </>
  );
}

export default SupportNavbar;